module.exports = __webpack_public_path__ + "static/media/spinning_dynamic.18bc9e5b.png";